import DataBlockContainer from "@/features/datablocks/details";

const EvidenceDetails = () => {
  return <DataBlockContainer />;
};

export default EvidenceDetails;
